import React from 'react';
import '../ui.css';

const Toolbar = ({ left, right }) => {
    return (
        <div className="ui-toolbar">
            {left && <div className="ui-toolbar-left">{left}</div>}
            {right && <div className="ui-toolbar-right">{right}</div>}
        </div>
    );
};

export default Toolbar;
